var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onair-messages-container"},[_c('iframe',{attrs:{"src":this.socialUrl}}),(!_vm.isLogged && _vm.showButton)?_c('button',{class:_vm.btnClass,on:{"click":_vm.doLoginEvt}},[_vm._v("Accedi per interagire in diretta")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }